import React from 'react';
import { Phone, Mail, MapPin, Calendar, ExternalLink, Linkedin } from 'lucide-react';
import { companyInfo } from '../mockData';

const partners = [
  { name: 'Corum', type: 'SCPI / Contrat capitalisation' },
  { name: 'InterInvest', type: 'Private Equity / Girardin' },
  { name: 'SwissLife', type: 'Assurance Vie / Prévoyance' },
  { name: 'Alta Roc', type: 'Private Equity' },
  { name: 'Selencia', type: 'Assurance Vie / PER' },
  { name: 'Intergestion', type: 'SCPI' },
  { name: 'Eres', type: 'Épargne salariale / PEE' },
  { name: 'Les 3 Colonnes', type: 'Viager mutualisé' },
  { name: 'Créquy Groupe', type: 'Malraux / Denormandie' },
  { name: 'Groupe CIR', type: 'Nue-propriété' },
  { name: 'Fiducial Gérance', type: 'Investissement forestier' },
  { name: 'Perl', type: 'Usufruit / Nue-propriété' },
  { name: 'Eiffel IG', type: 'Fonds obligataires' },
  { name: 'LIDR', type: 'LMNP' },
  { name: 'Marignan', type: 'Immobilier neuf' },
  { name: 'Alderan', type: 'SCPI' },
  { name: 'SEI', type: 'Gestion d\'actifs' },
  { name: '& bien d\'autres', type: '' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="section" style={{ background: 'var(--primary-brown)', color: 'var(--text-light)' }}>
      {/* Partners Banner */}
      <div style={{ 
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        paddingBottom: '2rem',
        marginBottom: '2rem',
        overflow: 'hidden'
      }}>
        <div className="container">
          <p style={{ 
            textAlign: 'center', 
            fontSize: '0.7rem', 
            color: 'rgba(255,255,255,0.5)', 
            textTransform: 'uppercase', 
            letterSpacing: '0.1em',
            marginBottom: '1rem'
          }}>Nos partenaires</p>
        </div>
        <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
          <div className="partners-scroll" style={{
            display: 'flex',
            gap: '2.5rem',
            animation: 'scroll-partners 35s linear infinite',
            width: 'max-content'
          }}>
            {[...partners, ...partners].map((p, i) => (
              <div key={i} style={{ 
                textAlign: 'center', 
                flexShrink: 0,
                minWidth: '90px'
              }}>
                <p style={{ 
                  color: 'rgba(255,255,255,0.85)', 
                  fontSize: '0.8rem', 
                  fontWeight: '600',
                  marginBottom: '0.2rem',
                  whiteSpace: 'nowrap'
                }}>{p.name}</p>
                <p style={{ 
                  color: 'var(--primary-gold)', 
                  fontSize: '0.6rem', 
                  opacity: 0.8,
                  whiteSpace: 'nowrap'
                }}>{p.type}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="grid-3" style={{ marginBottom: '3rem' }}>
          {/* Logo et description */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_02301d40-e1b7-4c3b-a98b-eccef76882c0/artifacts/ycezj9uw_Logo%20Horizontale.jpg" 
                alt="ActiV Patrimoine.fr" 
                style={{ height: '40px', width: 'auto', filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.8)', marginBottom: '1rem' }}>
              {companyInfo.description}
            </p>
            <div className="flex" style={{ gap: '1rem' }}>
              <a 
                href={`tel:${companyInfo.phone}`}
                style={{ color: 'var(--text-light)', textDecoration: 'none' }}
              >
                <Phone size={20} />
              </a>
              <a 
                href={`mailto:${companyInfo.email}`}
                style={{ color: 'var(--text-light)', textDecoration: 'none' }}
              >
                <Mail size={20} />
              </a>
              <a 
                href="https://www.linkedin.com/in/arthur-vacogne-cabinet-activ-patrimoine-89538647/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--text-light)', textDecoration: 'none' }}
              >
                <Linkedin size={20} />
              </a>
              <a 
                href={companyInfo.calendlyUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--text-light)', textDecoration: 'none' }}
              >
                <Calendar size={20} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="heading-3" style={{ color: 'var(--text-light)', marginBottom: '1rem' }}>
              Navigation
            </h4>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <a 
                  href="#accueil" 
                  style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  Accueil
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a 
                  href="#services" 
                  style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  Services
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a 
                  href="#a-propos" 
                  style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  À Propos
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a 
                  href="#calculateur" 
                  style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  Calculateur
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a 
                  href="#avis" 
                  style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  Avis Clients
                </a>
              </li>
              <li>
                <a 
                  href="#contact" 
                  style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact rapide */}
          <div>
            <h4 className="heading-3" style={{ color: 'var(--text-light)', marginBottom: '1rem' }}>
              Contact rapide
            </h4>
            
            <div style={{ marginBottom: '1rem' }}>
              <div className="flex" style={{ alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <Phone size={16} style={{ color: 'var(--primary-gold)' }} />
                <a 
                  href={`tel:${companyInfo.phone}`}
                  style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  {companyInfo.phone}
                </a>
              </div>
              
              <div className="flex" style={{ alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <Mail size={16} style={{ color: 'var(--primary-gold)' }} />
                <a 
                  href={`mailto:${companyInfo.email}`}
                  style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', fontSize: '0.875rem' }}
                >
                  {companyInfo.email}
                </a>
              </div>
              
              <div className="flex" style={{ alignItems: 'center', gap: '0.5rem' }}>
                <MapPin size={16} style={{ color: 'var(--primary-gold)' }} />
                <span style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.875rem' }}>
                  {companyInfo.address}
                </span>
              </div>
            </div>

            <a 
              href={companyInfo.calendlyUrl}
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-secondary"
              style={{ 
                background: 'transparent',
                borderColor: 'var(--primary-gold)',
                color: 'var(--primary-gold)'
              }}
            >
              <Calendar size={16} />
              Prendre RDV
            </a>
          </div>
        </div>

        {/* Séparateur */}
        <div style={{ 
          height: '1px', 
          background: 'rgba(255, 255, 255, 0.2)', 
          margin: '2rem 0' 
        }}></div>

        {/* Informations réglementaires détaillées */}
        <div style={{ marginBottom: '2rem' }}>
          <h4 className="heading-3" style={{ color: 'var(--text-light)', marginBottom: '1rem', fontSize: '1rem' }}>
            Informations réglementaires
          </h4>
          <div style={{ 
            color: 'rgba(255, 255, 255, 0.8)', 
            fontSize: '0.75rem',
            lineHeight: 1.5,
            marginBottom: '1rem'
          }}>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              <strong>Arthur Vacogne</strong> - Conseiller en Investissements Financiers
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              Certifié AMF - Membre de la Chambre Nationale des Conseils Experts Financiers
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              <strong>RCS Annecy sous le n° 921 821 443</strong> - <strong>SIREN : 921821443</strong>
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              <strong>Immatriculé à l'ORIAS sous le N° 23001408</strong> - 
              <a 
                href="https://www.orias.fr" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'underline' }}
              > 
                {' '}www.orias.fr
              </a>
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              Association agréée par l'Autorité des Marchés Financiers
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              Mandataire d'Intermédiaire d'Assurance
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              Mandataire d'Intermédiaire d'Opération de Banque et Services de Paiement
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              Sous le contrôle de l'Autorité de Contrôle Prudentiel et de Résolution (ACPR)
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              4 Place de Budapest, CS 92459, 75436 PARIS CEDEX 9
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              Garantie financière et assurance RCP conformes au code des assurances
            </p>
          </div>
        </div>

        <div className="flex-between" style={{ flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <p style={{ 
              color: 'rgba(255, 255, 255, 0.6)', 
              fontSize: '0.75rem',
              margin: 0,
              lineHeight: 1.4
            }}>
              © {currentYear} Arthur Vacogne - ActiV Patrimoine.fr
              <br />
              Tous droits réservés
            </p>
          </div>
          
          <div className="flex" style={{ gap: '2rem', flexWrap: 'wrap' }}>
            <a 
              href="#mentions-legales"
              style={{ 
                color: 'rgba(255, 255, 255, 0.6)', 
                textDecoration: 'none', 
                fontSize: '0.75rem' 
              }}
              onClick={(e) => {
                e.preventDefault();
                alert('Page mentions légales à créer');
              }}
            >
              Mentions légales
            </a>
            <a 
              href="#politique-confidentialite"
              style={{ 
                color: 'rgba(255, 255, 255, 0.6)', 
                textDecoration: 'none', 
                fontSize: '0.75rem' 
              }}
              onClick={(e) => {
                e.preventDefault();
                alert('Page politique de confidentialité à créer');
              }}
            >
              Politique de confidentialité
            </a>
            <a 
              href="https://www.orias.fr/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                color: 'rgba(255, 255, 255, 0.6)', 
                textDecoration: 'none', 
                fontSize: '0.75rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem'
              }}
            >
              ORIAS
              <ExternalLink size={12} />
            </a>
          </div>

          {/* SEO - Contenu invisible pour le référencement */}
          <div className="sr-only" aria-hidden="true">
            <h2>Conseiller en gestion de patrimoine Annecy - Arthur Vacogne</h2>
            <p>Arthur Vacogne, gestionnaire de patrimoine indépendant basé à Annecy-le-Vieux en Haute-Savoie (74). 
            Spécialiste en gestion de patrimoine, optimisation fiscale, investissement immobilier locatif, 
            SCPI, assurance vie, assurance vie luxembourgeoise, placement financier haut de gamme et préparation retraite. 
            Cabinet de conseil en investissement à Annecy, intervenant sur toute la Haute-Savoie (74) : 
            Annecy, Annecy-le-Vieux, Cran-Gevrier, Seynod, Meythet, Argonay, Veyrier-du-Lac, Talloires, 
            Thonon-les-Bains, Évian-les-Bains, Annemasse, Cluses, Bonneville, Sallanches, Chamonix, Rumilly, 
            Saint-Julien-en-Genevois, La Roche-sur-Foron, Passy, Faverges. 
            Également présent en Savoie (73) : Chambéry, Aix-les-Bains, Albertville, Montmélian, La Motte-Servolex. 
            En Isère (38) : Grenoble, Voiron, Bourgoin-Jallieu, Meylan, Échirolles, Saint-Martin-d'Hères. 
            En Rhône (69) : Lyon, Villeurbanne, Vénissieux, Caluire-et-Cuire, Bron, Écully, Tassin-la-Demi-Lune. 
            Intervention France entière.</p>
            <p>Services complets de gestion de patrimoine : bilan patrimonial gratuit et personnalisé, 
            conseil en investissement financier, défiscalisation et optimisation fiscale, 
            immobilier locatif (Pinel, LMNP, Denormandie), SCPI de rendement et pierre papier, 
            assurance vie multisupport et fonds euros, PER plan épargne retraite individuel et collectif, 
            épargne salariale et intéressement, trésorerie entreprise et placement professionnel, 
            transmission familiale donation et succession, protection du patrimoine et prévoyance, 
            renégociation et courtage assurance de prêt immobilier, conseil patrimoine frontaliers Suisse et transfrontalier. 
            Conseiller en Investissements Financiers (CIF) membre de la Chambre Nationale des CIF. 
            CGP indépendant certifié.</p>
            <p>Expertise reconnue : gestionnaire de patrimoine Annecy, CGP Haute-Savoie 74, 
            conseiller patrimoine Savoie 73, gestion patrimoine Isère 38, conseiller financier Rhône 69, 
            CGP frontalier Suisse Genève, investissement Annecy-le-Vieux, optimisation fiscale Haute-Savoie, 
            placement financier Annecy, immobilier locatif Haute-Savoie Savoie, SCPI Annecy, 
            assurance vie Annecy, épargne retraite Haute-Savoie, défiscalisation Annecy, 
            conseil investissement Chambéry Grenoble Lyon, patrimoine indépendant Alpes, 
            renégocier assurance de prêt Annecy, courtier assurance prêt immobilier Haute-Savoie, 
            épargne frontalier, fiscalité frontalier Suisse, retraite complémentaire, 
            placements financiers sécurisés, diversification patrimoniale, revenus complémentaires, 
            préparation études enfants, budget familial, protection sociale indépendant,
            capital investissement, private equity, fonds d'investissement, gestion alternative,
            club deal immobilier, investissement non coté, fonds de capital risque, venture capital.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;